import ApiRequestManagerInstance from '../ApiRequestManager';
import Genre from '../../classes/genre';
import TranslationManager from '../../assets/locale/translationsManager';
import { IGenre, IGenresRequest } from '../../types/interfaces/genre';

export default function genresRequest() {
  const promise = new Promise<Genre[]>(async (resolve, reject) => {
    try {
      const response: IGenresRequest = (await ApiRequestManagerInstance.get({
        endpoint: {
          url: 'cdnSyncUrl',
          section: 'media',
          subsection: `genres.${TranslationManager.currentLanguage}.json`,
        },
      })) as unknown as IGenresRequest;
      const genres = response.data.map((genre: IGenre) => new Genre(genre));
      resolve(genres);
    } catch (e) {
      console.error(e);
      reject([]);
    }
  });

  return promise;
}
